import { gql } from '@apollo/client';
import { AnyTableEventFieldsFragment } from '../../../utils/apollo/events/any';

export default gql`
  query GetAnyTableEvent($schemaId: ID!, $key: String!) {
    anyTableEvent(schemaId: $schemaId, key: $key) {
      ...AnyTableEventFields
    }
  }

  ${AnyTableEventFieldsFragment}
`;
